/* Fayar theme — Shopify OS 2.0 interactions */
(function () {
  'use strict';

  var hasGsap = function () {
    return !!(window.gsap && window.ScrollTrigger);
  };

  function initReveal() {
    if (hasGsap()) return;
    var elements = Array.prototype.slice.call(document.querySelectorAll('.reveal, .reveal-scale'));
    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    function reveal(el) {
      el.classList.add('is-visible');
      observer.unobserve(el);
      var idx = elements.indexOf(el);
      if (idx > -1) elements.splice(idx, 1);
    }

    elements.forEach(function (el) {
      observer.observe(el);
    });

    var ticking = false;
    function revealPassed() {
      ticking = false;
      for (var i = elements.length - 1; i >= 0; i--) {
        if (elements[i].getBoundingClientRect().top < window.innerHeight) {
          reveal(elements[i]);
        }
      }
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking && elements.length) {
          ticking = true;
          requestAnimationFrame(revealPassed);
        }
      },
      { passive: true }
    );
  }

  function initSplitWords() {
    if (hasGsap()) return;
    document.querySelectorAll('[data-split-words]').forEach(function (el) {
      var words = el.textContent.trim().split(/\s+/);
      el.textContent = '';
      words.forEach(function (word, i) {
        var span = document.createElement('span');
        span.className = 'word';
        span.style.setProperty('--word-i', i);
        span.textContent = word;
        el.appendChild(span);
        el.appendChild(document.createTextNode(' '));
      });
    });
  }

  function initHeader() {
    var header = document.querySelector('[data-sticky-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-menu-drawer]');
    var scrim = document.querySelector('[data-menu-close]');
    if (!toggle || !drawer) return;

    var setMenu = function (open) {
      drawer.classList.toggle('is-open', open);
      document.body.classList.toggle('is-menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      if (scrim) scrim.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        var first = drawer.querySelector('a');
        if (first) first.focus();
      }
    };

    toggle.addEventListener('click', function () {
      setMenu(!drawer.classList.contains('is-open'));
    });
    if (scrim) scrim.addEventListener('click', function () { setMenu(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        setMenu(false);
        toggle.focus();
      }
    });
  }

  function initCounters() {
    if (hasGsap()) return;
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length || !('IntersectionObserver' in window)) return;

    var animate = function (el) {
      var target = parseInt(el.dataset.target, 10) || 0;
      var duration = 1600;
      var start = performance.now();
      var step = function (now) {
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased).toLocaleString();
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );
    counters.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initTestimonials() {
    document.querySelectorAll('[data-testimonial-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-testimonial-track]');
      var prev = slider.querySelector('[data-testimonial-prev]');
      var next = slider.querySelector('[data-testimonial-next]');
      if (!track) return;
      var scrollAmount = function () {
        var card = track.querySelector('.testimonial-card');
        return card ? card.offsetWidth + 24 : 300;
      };
      prev &&
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
        });
      next &&
        next.addEventListener('click', function () {
          track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
        });
    });
  }

  // Locale strings from theme.liquid. Module scope: the cart drawer, quick
  // view and search overlay all read these, not just the product page.
  var strings = (window.theme && window.theme.strings) || {};

  function cartRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  /**
   * Format cents using the shop's money_format (set on window.theme in
   * theme.liquid). Falls back to Shopify.formatMoney when shopify_common.js
   * happens to be present, then to a plain decimal — never to a hardcoded
   * currency symbol, which would be wrong for any non-USD shop.
   */
  function formatMoney(cents) {
    var format = window.theme && window.theme.moneyFormat;

    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    if (!format) {
      return (cents / 100).toFixed(2);
    }

    var value = cents / 100;

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_match, token) {
      switch (token) {
        case 'amount':
          return group(value.toFixed(2), ',', '.');
        case 'amount_no_decimals':
          return group(Math.round(value).toString(), ',', '');
        case 'amount_with_comma_separator':
          return group(value.toFixed(2), '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return group(Math.round(value).toString(), '.', '');
        case 'amount_with_apostrophe_separator':
          return group(value.toFixed(2), "'", '.');
        case 'amount_with_space_separator':
          return group(value.toFixed(2), ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return group(Math.round(value).toString(), ' ', '');
        default:
          return group(value.toFixed(2), ',', '.');
      }
    });

    function group(fixed, thousands, decimalSep) {
      var parts = fixed.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] && decimalSep ? whole + decimalSep + parts[1] : whole;
    }
  }

  function updateCartCount() {
    fetch(cartRoot() + 'cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var badge = document.querySelector('[data-cart-count]');
        if (!badge) return;
        badge.textContent = cart.item_count;
        badge.classList.toggle('is-empty', cart.item_count === 0);
        badge.classList.remove('bump');
        void badge.offsetWidth;
        badge.classList.add('bump');
      })
      .catch(function () {});
  }

  function initProductPage() {
    var mainWrap = document.querySelector('[data-main-media]');
    document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainWrap) return;
        document.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');

        var mediaId = thumb.dataset.mediaId;
        var template = mediaId
          ? document.querySelector('[data-media-template="' + mediaId + '"]')
          : null;

        mainWrap.style.opacity = '0';
        setTimeout(function () {
          if (template) {
            mainWrap.innerHTML = template.innerHTML;
          } else if (thumb.dataset.src) {
            mainWrap.innerHTML =
              '<img src="' +
              thumb.dataset.src +
              '" alt="" width="600" height="600" data-main-image class="product-page__media">';
          }
          mainWrap.style.transition = 'opacity .3s';
          mainWrap.style.opacity = '1';
        }, 150);
      });
    });

    document.querySelectorAll('.quantity-picker').forEach(function (picker) {
      var input = picker.querySelector('input[name="quantity"]');
      if (!input) return;
      var minus = picker.querySelector('[data-qty-minus]');
      var plus = picker.querySelector('[data-qty-plus]');
      minus &&
        minus.addEventListener('click', function () {
          input.value = Math.max(1, parseInt(input.value, 10) - 1);
        });
      plus &&
        plus.addEventListener('click', function () {
          input.value = parseInt(input.value, 10) + 1;
        });
    });

    var form = document.querySelector('[data-product-form], .product-form');
    if (!form) return;

    var variantsScript = form.querySelector('[data-variants-json]');
    var variantInput = form.querySelector('[data-variant-id]');
    var selects = form.querySelectorAll('[data-option-select]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var addLabel = strings.addToCart || (submitBtn ? submitBtn.textContent.trim() : 'Add to cart');
    var soldLabel = strings.soldOut || 'Sold out';

    if (variantsScript && selects.length) {
      var variants = JSON.parse(variantsScript.textContent);
      var updateVariant = function () {
        var chosen = Array.from(selects).map(function (s) {
          return s.value;
        });
        var match = variants.find(function (v) {
          return chosen.every(function (val, i) {
            return v['option' + (i + 1)] === val;
          });
        });
        // No variant for this combination — block checkout rather than leaving
        // the previously selected variant id in the form.
        if (!match) {
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = strings.unavailable || 'Unavailable';
          }
          return;
        }

        if (variantInput) {
          variantInput.value = match.id;
        }

        var priceEl = document.querySelector('[data-price]');
        if (priceEl) {
          priceEl.textContent = formatMoney(match.price);
        }

        var compareEl = document.querySelector('[data-compare-price]');
        if (compareEl) {
          var showCompare = match.compare_at_price && match.compare_at_price > match.price;
          compareEl.textContent = showCompare ? formatMoney(match.compare_at_price) : '';
          compareEl.hidden = !showCompare;
        }

        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available ? addLabel : soldLabel;
        }
      };
      selects.forEach(function (s) {
        s.addEventListener('change', updateVariant);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!submitBtn || submitBtn.disabled || !variantInput) return;
      var original = submitBtn.innerHTML;
      var qtyInput = form.querySelector('input[name="quantity"]');
      submitBtn.disabled = true;
      submitBtn.textContent = strings.adding || 'Adding...';

      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(variantInput.value, 10),
              quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1
            }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          submitBtn.classList.add('is-added');
          submitBtn.textContent = strings.added || 'Added';
          updateCartCount();
          setTimeout(function () {
            submitBtn.classList.remove('is-added');
            submitBtn.innerHTML = original;
            submitBtn.disabled = false;
          }, 1600);
        })
        .catch(function () {
          submitBtn.innerHTML = original;
          submitBtn.disabled = false;
          form.submit();
        });
    });
  }

  // Country/currency selector: submit on change so no extra button is needed.
  // The <noscript> fallback button covers JS-off.
  function initLocalization() {
    document.querySelectorAll('[data-localization-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  // Shop by pet: both panels are already in the DOM, so switching is instant.
  function initShopByPet() {
    document.querySelectorAll('[data-shop-by-pet]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-pet-tab]');
      var panels = root.querySelectorAll('[data-pet-panel]');
      if (!tabs.length) return;

      var select = function (pet) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-pet-tab') === pet;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', String(on));
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-pet-panel') === pet;
          p.hidden = !on;
          p.classList.toggle('is-hidden', !on);
          if (on) {
            // Re-run the reveal so cards animate in rather than appearing flat.
            p.querySelectorAll('.reveal').forEach(function (el) {
              el.classList.remove('is-visible');
              void el.offsetWidth;
              el.classList.add('is-visible');
            });
          }
        });
        root.setAttribute('data-active-pet', pet);
      };

      tabs.forEach(function (t) {
        t.addEventListener('click', function () { select(t.getAttribute('data-pet-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
          e.preventDefault();
          var list = Array.prototype.slice.call(tabs);
          var next = list[(list.indexOf(t) + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
          next.focus();
          select(next.getAttribute('data-pet-tab'));
        });
      });

      root.setAttribute('data-active-pet', 'dog');
    });
  }

  // Shop mega-menu: hover on pointer devices, click/keyboard everywhere.
  function initMegaMenu() {
    document.querySelectorAll('[data-mega]').forEach(function (root) {
      var trigger = root.querySelector('[data-mega-trigger]');
      var panel = root.querySelector('[data-mega-panel]');
      if (!trigger || !panel) return;
      var closeTimer = null;

      var open = function (state) {
        clearTimeout(closeTimer);
        panel.hidden = !state;
        trigger.setAttribute('aria-expanded', String(state));
      };

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open(panel.hidden);
      });

      if (window.matchMedia('(hover: hover)').matches) {
        root.addEventListener('mouseenter', function () { open(true); });
        root.addEventListener('mouseleave', function () {
          closeTimer = setTimeout(function () { open(false); }, 160);
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) { open(false); trigger.focus(); }
      });
      document.addEventListener('click', function (e) {
        if (!panel.hidden && !root.contains(e.target)) open(false);
      });

      // Pet rail switches which collection panel is shown.
      var pets = panel.querySelectorAll('[data-mega-pet]');
      var groups = panel.querySelectorAll('[data-mega-panel-pet]');
      var pick = function (pet) {
        pets.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-mega-pet') === pet); });
        groups.forEach(function (g) { g.hidden = g.getAttribute('data-mega-panel-pet') !== pet; });
      };
      pets.forEach(function (b) {
        var pet = b.getAttribute('data-mega-pet');
        b.addEventListener('click', function () { pick(pet); });
        b.addEventListener('mouseenter', function () { pick(pet); });
      });
    });
  }


  /* ------------------------------------------------------------------ *
   * Cinematic opening. Once per session; the curtain parts from centre.
   * ------------------------------------------------------------------ */
  function initIntro() {
    var pre = document.querySelector('[data-preloader]');
    if (!pre) return;

    var done = function () {
      pre.classList.add('is-done');
      pre.dispatchEvent(new CustomEvent('fayar:intro-done'));
      setTimeout(function () { if (pre.parentNode) pre.remove(); }, 2100);
    };

    var seen = false;
    try { seen = sessionStorage.getItem('fayar:intro') === '1'; } catch (e) {}
    if (seen || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      pre.remove();
      return;
    }
    try { sessionStorage.setItem('fayar:intro', '1'); } catch (e) {}

    document.body.classList.add('is-intro');
    // Long enough for the push-in and the lockup to land, short enough that a
    // returning shopper is not made to wait: the sequence runs once a session.
    setTimeout(function () {
      document.body.classList.remove('is-intro');
      done();
    }, 2600);
  }


  /* ------------------------------------------------------------------ *
   * Exit-intent offer: a real hand of blackjack.
   * The deck is shuffled and dealt honestly; the dealer draws to 16 and
   * stands on 17. A loss offers one rematch rather than being flipped to
   * a win, so the game is a game rather than theatre.
   * ------------------------------------------------------------------ */
  function initExitOffer() {
    var root = document.querySelector('[data-exit-offer]');
    if (!root) return;

    var KEY = 'fayar:exit-offer';
    var seen = false;
    try { seen = localStorage.getItem(KEY) === 'done'; } catch (e) {}
    if (seen) return;

    var q = function (s) { return root.querySelector(s); };
    var deck = [], player = [], dealer = [], armed = false, rematched = false;

    var SUITS = ['♠', '♥', '♦', '♣'];
    var RANKS = ['A','2','3','4','5','6','7','8','9','10','J','Q','K'];

    function shuffle() {
      deck = [];
      SUITS.forEach(function (s) { RANKS.forEach(function (r) { deck.push({ r: r, s: s }); }); });
      for (var i = deck.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = deck[i]; deck[i] = deck[j]; deck[j] = t;
      }
    }
    function draw() { return deck.pop(); }

    function total(hand) {
      var sum = 0, aces = 0;
      hand.forEach(function (c) {
        if (c.r === 'A') { aces++; sum += 11; }
        else if (['J','Q','K'].indexOf(c.r) > -1) sum += 10;
        else sum += parseInt(c.r, 10);
      });
      while (sum > 21 && aces > 0) { sum -= 10; aces--; }
      return sum;
    }

    function cardEl(c, faceDown) {
      var d = document.createElement('span');
      d.className = 'exitcard' + (faceDown ? ' is-down' : '');
      d.innerHTML = faceDown ? '' :
        '<b>' + c.r + '</b><i>' + c.s + '</i>';
      if (!faceDown && (c.s === '♥' || c.s === '♦')) d.classList.add('is-red');
      return d;
    }

    function render(hideHole) {
      var dc = q('[data-dealer-cards]'), pc = q('[data-player-cards]');
      dc.innerHTML = ''; pc.innerHTML = '';
      dealer.forEach(function (c, i) { dc.appendChild(cardEl(c, hideHole && i === 1)); });
      player.forEach(function (c) { pc.appendChild(cardEl(c, false)); });
      q('[data-dealer-score]').textContent = hideHole ? total([dealer[0]]) + ' + ?' : total(dealer);
      q('[data-player-score]').textContent = total(player);
    }

    function show(sel, on) { var el = q(sel); if (el) el.hidden = !on; }

    function finish(won) {
      show('[data-exit-actions]', false);
      show('[data-exit-rules]', false);
      show('[data-exit-result]', true);
      render(false);
      var out = q('[data-exit-outcome]');
      if (won) {
        out.textContent = total(dealer) > 21 ? 'Dealer busts. Your hand, your gift.' : 'You beat the dealer.';
        show('[data-exit-form]', true);
        q('[data-exit-again]').hidden = true;
      } else {
        out.textContent = total(player) > 21 ? 'Bust. The house takes that one.' : 'Dealer takes it.';
        show('[data-exit-form]', false);
        q('[data-exit-again]').hidden = rematched;
        if (rematched) {
          out.textContent += ' Thanks for playing.';
          try { localStorage.setItem(KEY, 'done'); } catch (e) {}
        }
      }
    }

    function dealerPlay() {
      while (total(dealer) < 17) dealer.push(draw());
      var p = total(player), d = total(dealer);
      finish(d > 21 || p > d);
    }

    function deal() {
      shuffle();
      player = [draw(), draw()];
      dealer = [draw(), draw()];
      show('[data-exit-table]', true);
      show('[data-exit-actions]', true);
      show('[data-exit-rules]', true);
      show('[data-exit-start]', false);
      show('[data-exit-result]', false);
      render(true);
      if (total(player) === 21) { dealerPlay(); }
    }

    function open() {
      if (root.hidden === false) return;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-layer-open');
    }
    function close() {
      root.hidden = true;
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('is-layer-open');
      try { localStorage.setItem(KEY, 'done'); } catch (e) {}
    }

    q('[data-exit-deal]').addEventListener('click', deal);
    q('[data-exit-hit]').addEventListener('click', function () {
      player.push(draw());
      render(true);
      if (total(player) >= 21) dealerPlay();
    });
    q('[data-exit-stand]').addEventListener('click', dealerPlay);
    q('[data-exit-again]').addEventListener('click', function () { rematched = true; deal(); });
    root.querySelectorAll('[data-exit-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) close();
    });

    q('[data-exit-form]').addEventListener('submit', function (e) {
      e.preventDefault();
      var email = q('#ExitGameEmail').value.trim();
      if (!email) return;
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', email);
      body.append('contact[accepts_marketing]', 'true');
      fetch(cartRoot() + 'contact', { method: 'POST', body: body })
        .catch(function () {})
        .then(function () {
          show('[data-exit-form]', false);
          show('[data-exit-code]', true);
          try { localStorage.setItem(KEY, 'done'); } catch (e) {}
        });
    });

    var copyBtn = q('[data-exit-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      var code = copyBtn.getAttribute('data-exit-copy');
      var label = copyBtn.textContent;
      var done = function () {
        copyBtn.textContent = 'Copied';
        setTimeout(function () { copyBtn.textContent = label; }, 1600);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done).catch(done);
      else done();
    });

    // Arm only once the visitor has actually looked at something, so it reads
    // as a parting offer rather than an ambush on arrival.
    setTimeout(function () { armed = true; }, 12000);

    if (window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (armed && !e.relatedTarget && e.clientY <= 0) open();
      });
    } else {
      // Touch has no mouse-leave: use a decisive upward flick near the top.
      var lastY = window.scrollY, idle = null;
      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        if (armed && lastY - y > 90 && y < 260) open();
        lastY = y;
        clearTimeout(idle);
        idle = setTimeout(function () { if (armed) open(); }, 45000);
      }, { passive: true });
    }
  }

  function initSorting() {
    var sortSelect = document.querySelector('[data-sort-by]');
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  function initOurSpot() {
    document.querySelectorAll('[data-our-spot]').forEach(function (root) {
      var track = root.querySelector('[data-our-spot-track]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-spot-card], .our-spot-section__card'));
      var paused = false;
      var holdUntil = 0;

      function updateActive() {
        var box = track.getBoundingClientRect();
        var scored = cards
          .map(function (card) {
            var r = card.getBoundingClientRect();
            var visible = Math.max(0, Math.min(r.right, box.right) - Math.max(r.left, box.left));
            return { card: card, visible: visible };
          })
          .filter(function (c) {
            return c.visible > 40;
          })
          .sort(function (a, b) {
            return b.visible - a.visible;
          })
          .slice(0, 2);

        var active = scored.map(function (s) {
          return s.card;
        });
        cards.forEach(function (card) {
          var video = card.querySelector('video');
          if (!video) return;
          if (active.indexOf(card) !== -1) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }

      track.addEventListener('scroll', updateActive, { passive: true });
      window.addEventListener('resize', updateActive);
      updateActive();

      var prev = root.querySelector('[data-our-spot-prev]');
      var next = root.querySelector('[data-our-spot-next]');
      prev &&
        prev.addEventListener('click', function () {
          track.scrollBy({ left: -320, behavior: 'smooth' });
        });
      next &&
        next.addEventListener('click', function () {
          track.scrollBy({ left: 320, behavior: 'smooth' });
        });

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      track.addEventListener('mouseenter', function () {
        paused = true;
      });
      track.addEventListener('mouseleave', function () {
        paused = false;
      });
      track.addEventListener(
        'touchstart',
        function () {
          paused = true;
        },
        { passive: true }
      );
      track.addEventListener(
        'touchend',
        function () {
          paused = false;
        },
        { passive: true }
      );

      var last = performance.now();
      var tick = function (now) {
        var dt = Math.min(32, now - last);
        last = now;
        if (!paused && now >= holdUntil) {
          var max = track.scrollWidth - track.clientWidth;
          if (max > 0) {
            if (track.scrollLeft >= max - 2) {
              holdUntil = now + 1400;
              track.scrollLeft = 0;
            } else {
              track.scrollLeft += (dt / 1000) * 26;
            }
          }
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }

  function initProductCardVideos() {
    document.querySelectorAll('[data-product-card] [data-has-video]').forEach(function (media) {
      var video = media.querySelector('video');
      if (!video) return;
      media.addEventListener('mouseenter', function () {
        video.currentTime = 0;
        video.play().catch(function () {});
      });
      media.addEventListener('mouseleave', function () {
        video.pause();
      });
      media.addEventListener(
        'touchstart',
        function () {
          video.play().catch(function () {});
        },
        { passive: true }
      );
    });
  }

  /* ------------------------------------------------------------------ *
   * Overlays: shared open/close, focus handling and Escape
   * ------------------------------------------------------------------ */

  var lastFocused = null;

  function openLayer(el) {
    if (!el) return;
    lastFocused = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-layer-open');
    var focusable = el.querySelector('input, button, a[href]');
    if (focusable) focusable.focus();
  }

  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    if (!document.querySelector('[data-cart-drawer]:not([hidden]), [data-quick-view]:not([hidden]), [data-search-overlay]:not([hidden])')) {
      document.body.classList.remove('is-layer-open');
    }
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function initLayers() {
    document.addEventListener('click', function (event) {
      var closer = event.target.closest('[data-drawer-close], [data-modal-close], [data-overlay-close]');
      if (closer) {
        closeLayer(closer.closest('[data-cart-drawer], [data-quick-view], [data-search-overlay]'));
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      ['[data-cart-drawer]', '[data-quick-view]', '[data-search-overlay]'].forEach(function (sel) {
        closeLayer(document.querySelector(sel + ':not([hidden])'));
      });
    });
  }

  /* ------------------------------------------------------------------ *
   * Cart drawer
   * ------------------------------------------------------------------ */

  function renderCartDrawer(cart) {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var itemsEl = drawer.querySelector('[data-drawer-items]');
    var emptyEl = drawer.querySelector('[data-drawer-empty]');
    var footEl = drawer.querySelector('[data-drawer-foot]');
    var countEl = drawer.querySelector('[data-drawer-count]');
    var subtotalEl = drawer.querySelector('[data-drawer-subtotal]');

    if (countEl) countEl.textContent = cart.item_count;

    itemsEl.querySelectorAll('[data-drawer-line]').forEach(function (n) { n.remove(); });

    if (!cart.item_count) {
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      return;
    }

    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    cart.items.forEach(function (item, index) {
      var row = document.createElement('div');
      row.className = 'drawer-line';
      row.setAttribute('data-drawer-line', '');

      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="" width="64" height="64" loading="lazy">'
        : '';

      row.innerHTML =
        '<a class="drawer-line__media" href="' + item.url + '">' + img + '</a>' +
        '<div class="drawer-line__info">' +
          '<a class="drawer-line__title" href="' + item.url + '">' + item.product_title + '</a>' +
          (item.variant_title ? '<span class="drawer-line__variant">' + item.variant_title + '</span>' : '') +
          '<span class="drawer-line__price">' + formatMoney(item.final_line_price) + '</span>' +
          '<div class="drawer-line__qty">' +
            '<button type="button" data-line-change="' + (index + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line-change="' + (index + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="drawer-line__remove" data-line-change="' + (index + 1) + '" data-qty="0">' +
          (strings.remove || 'Remove') +
        '</button>';

      itemsEl.appendChild(row);
    });
  }

  function fetchCart(open) {
    return fetch(cartRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        renderCartDrawer(cart);
        var badge = document.querySelector('[data-cart-count]');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.classList.toggle('is-empty', cart.item_count === 0);
        }
        if (open) openLayer(document.querySelector('[data-cart-drawer]'));
        return cart;
      })
      .catch(function () {});
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    // The header cart icon is a real link to /cart; hijack it only when JS runs.
    var trigger = document.querySelector('[data-cart-icon]');
    if (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        fetchCart(true);
      });
    }

    drawer.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-line-change]');
      if (!btn) return;
      fetch(cartRoot() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: parseInt(btn.getAttribute('data-line-change'), 10),
          quantity: parseInt(btn.getAttribute('data-qty'), 10)
        })
      })
        .then(function (res) { return res.json(); })
        .then(renderCartDrawer)
        .then(function () { return fetchCart(false); });
    });

    document.addEventListener('fayar:cart-updated', function () { fetchCart(true); });
  }

  /* ------------------------------------------------------------------ *
   * Quick view — pulls the real product section, no duplicated markup
   * ------------------------------------------------------------------ */

  function initQuickView() {
    var modal = document.querySelector('[data-quick-view]');
    if (!modal) return;
    var body = modal.querySelector('[data-quick-view-body]');

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-quick-view-open]');
      if (!trigger) return;
      event.preventDefault();

      var handle = trigger.getAttribute('data-quick-view-open');
      body.innerHTML = '<div class="modal__loading">' + (strings.loading || 'Loading') + '</div>';
      openLayer(modal);

      fetch(cartRoot() + 'products/' + handle + '?section_id=main-product')
        .then(function (res) {
          if (!res.ok) throw new Error('quick view fetch failed');
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var details = doc.querySelector('.product-page__details');
          var media = doc.querySelector('.product-page__main-image');
          body.innerHTML = '';
          if (media) {
            var mediaWrap = document.createElement('div');
            mediaWrap.className = 'modal__media';
            mediaWrap.innerHTML = media.innerHTML;
            body.appendChild(mediaWrap);
          }
          if (details) {
            var detailWrap = document.createElement('div');
            detailWrap.className = 'modal__details';
            detailWrap.innerHTML = details.innerHTML;
            body.appendChild(detailWrap);
          }
          bindQuickViewForm(body);
        })
        .catch(function () {
          body.innerHTML = '<p class="modal__loading">' +
            (strings.quickViewError || 'Could not load this product.') +
            ' <a href="' + cartRoot() + 'products/' + handle + '">' +
            (strings.viewProduct || 'View product') + '</a></p>';
        });
    });
  }

  function bindQuickViewForm(scope) {
    var form = scope.querySelector('form[action*="/cart/add"], .product-form');
    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (!idInput) return;
      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(idInput.value, 10),
            quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1
          }]
        })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          closeLayer(document.querySelector('[data-quick-view]'));
          document.dispatchEvent(new CustomEvent('fayar:cart-updated'));
        });
    });
  }

  /* ------------------------------------------------------------------ *
   * Search overlay with predictive results
   * ------------------------------------------------------------------ */

  function initSearchOverlay() {
    var overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;

    var input = overlay.querySelector('[data-search-input]');
    var results = overlay.querySelector('[data-search-results]');
    var timer = null;

    document.querySelectorAll('[data-search-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        openLayer(overlay);
      });
    });

    if (!input) return;
    input.addEventListener('input', function () {
      var term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(function () {
        var url = cartRoot() + 'search/suggest.json?q=' + encodeURIComponent(term) +
                  '&resources[type]=product&resources[limit]=6';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              results.innerHTML = '<p class="overlay__empty">' + (strings.noResults || 'No results') + '</p>';
              return;
            }
            results.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="" width="56" height="56" loading="lazy">'
                : '';
              return '<a class="search-hit" href="' + p.url + '">' +
                       '<span class="search-hit__media">' + img + '</span>' +
                       '<span class="search-hit__body">' +
                         '<span class="search-hit__title">' + p.title + '</span>' +
                         '<span class="search-hit__price">' + (p.price ? formatMoney(parseInt(p.price, 10)) : '') + '</span>' +
                       '</span>' +
                     '</a>';
            }).join('');
          })
          .catch(function () { results.innerHTML = ''; });
      }, 220);
    });
  }

  /* ------------------------------------------------------------------ *
   * Promo band: countdown to a real end date, and copy-code button
   * ------------------------------------------------------------------ */

  function initPromoBand() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var until = Date.parse(el.getAttribute('data-until'));
      if (isNaN(until)) return;

      var parts = {
        days: el.querySelector('[data-cd-days]'),
        hours: el.querySelector('[data-cd-hours]'),
        mins: el.querySelector('[data-cd-mins]'),
        secs: el.querySelector('[data-cd-secs]')
      };

      var tick = function () {
        var diff = until - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          clearInterval(id);
          return;
        }
        el.hidden = false;
        var s = Math.floor(diff / 1000);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        if (parts.days) parts.days.textContent = pad(Math.floor(s / 86400));
        if (parts.hours) parts.hours.textContent = pad(Math.floor(s / 3600) % 24);
        if (parts.mins) parts.mins.textContent = pad(Math.floor(s / 60) % 60);
        if (parts.secs) parts.secs.textContent = pad(s % 60);
      };

      var id = setInterval(tick, 1000);
      tick();
    });

    document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-copy-code');
        var done = function () {
          var original = btn.textContent;
          btn.textContent = btn.getAttribute('data-copied-label') || 'Copied';
          setTimeout(function () { btn.textContent = original; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initSplitWords();
    initReveal();
    initHeader();
    initCounters();
    initTestimonials();
    initProductPage();
    initSorting();
    initIntro();
    initExitOffer();
    initShopByPet();
    initMegaMenu();
    initLocalization();
    initOurSpot();
    initProductCardVideos();
    initLayers();
    initCartDrawer();
    initQuickView();
    initSearchOverlay();
    initPromoBand();
  });
})();
